import { motion } from 'framer-motion';
import { trackEvent } from '../../lib/analytics';
import { useConsultaModal } from '../../context/ConsultaModalContext';

const ease = [0.21, 0.47, 0.32, 0.98] as [number, number, number, number];

const fadeUp = (delay: number) => ({
    initial: { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.35, delay, ease },
});

export const LandingHero = () => {
    const { open } = useConsultaModal();
    return (
        <header className="relative min-h-[100dvh] flex items-center pt-20 overflow-hidden bg-pacces-ebony">
            {/* Background Image: Corporate Architecture Asset */}
            <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80"
                alt="Arquitetura Corporativa Moderna - Pacces Advogados"
                className="absolute inset-0 w-full h-full object-cover grayscale brightness-[0.25] transition-transform duration-[10s] hover:scale-110"
                // High priority for LCP (Largest Contentful Paint) optimization
                fetchPriority="high"
            />

            {/* Dark Gradient Overlay for Contrast */}
            <div className="absolute inset-0 bg-gradient-to-r from-pacces-ebony via-pacces-ebony/80 to-transparent"></div>

            {/* Thin gold horizontal line — decorative entrance */}
            <motion.div
                className="absolute bottom-0 left-0 h-[1px] bg-pacces-gold/40"
                initial={{ width: 0 }}
                animate={{ width: '100%' }}
                transition={{ duration: 0.8, delay: 0.6, ease }}
            />

            <div className="relative max-w-7xl mx-auto px-6 flex flex-col items-start justify-center pb-12 text-white font-sans w-full min-h-[calc(100dvh-80px)] pt-32">
                <div className="max-w-4xl space-y-10">
                    <div className="space-y-4">
                        <motion.h1
                            className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-serif text-white tracking-tight uppercase whitespace-nowrap"
                            {...fadeUp(0.4)}
                        >
                            Pacces Advogados
                        </motion.h1>
                    </div>

                    <motion.p
                        className="text-xl text-stone-300 max-w-2xl leading-relaxed font-light text-left"
                        {...fadeUp(0.6)}
                    >
                        Advocacia estratégica de alta performance.
                    </motion.p>

                    <motion.div
                        className="flex flex-col sm:flex-row gap-6 pt-4"
                        {...fadeUp(0.8)}
                    >
                        <button
                            onClick={() => { open(); trackEvent('hero_cta_click', { cta: 'fale_conosco' }); }}
                            className="inline-flex items-center justify-center bg-pacces-gold text-pacces-ebony px-12 py-5 font-bold uppercase text-[12px] tracking-[0.4em] hover:bg-pacces-ebony hover:text-pacces-gold transition-all duration-300 rounded-sm shadow-xl min-w-[240px]"
                        >
                            Fale Conosco
                        </button>
                        <a
                            href="#about"
                            className="inline-flex items-center justify-center border border-white/30 text-white px-12 py-5 font-bold uppercase text-[12px] tracking-[0.4em] hover:bg-white hover:text-pacces-ebony transition-all duration-300 rounded-sm min-w-[240px]"
                        >
                            Saiba Mais
                        </a>
                    </motion.div>
                </div>
            </div>
        </header>
    );
};
